/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetTypeUsageDto
 */
export interface AssetTypeUsageDto {
    /**
     * Asset type key (symbol type)
     * @type {string}
     * @memberof AssetTypeUsageDto
     */
    type: string;
    /**
     * Number of users with this asset type
     * @type {number}
     * @memberof AssetTypeUsageDto
     */
    usersCount: number;
    /**
     * Total number of trades of this type
     * @type {number}
     * @memberof AssetTypeUsageDto
     */
    tradesCount: number;
    /**
     * Percentage of total users
     * @type {number}
     * @memberof AssetTypeUsageDto
     */
    percentage: number;
}

export function AssetTypeUsageDtoFromJSON(json: any): AssetTypeUsageDto {
    return AssetTypeUsageDtoFromJSONTyped(json, false);
}

export function AssetTypeUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetTypeUsageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'usersCount': json['usersCount'],
        'tradesCount': json['tradesCount'],
        'percentage': json['percentage'],
    };
}

export function AssetTypeUsageDtoToJSON(value?: AssetTypeUsageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'usersCount': value.usersCount,
        'tradesCount': value.tradesCount,
        'percentage': value.percentage,
    };
}

